import { ListSkeleton, TextSkeleton } from '@gitbook/spine-react';

import { SidePanelSheet } from './SidePanelSheet';

/**
 * Skeleton of a side panel sheet.
 */
export function SidePanelSheetSkeleton(props: { onClose?: () => void }) {
    const { onClose = () => {} } = props;
    return (
        <SidePanelSheet title={<TextSkeleton>Side panel title</TextSkeleton>} onClose={onClose}>
            <ListSkeleton className="p-4" />
        </SidePanelSheet>
    );
}
